/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import {HISTORY, RELEASE_TYPE, Solution} from '@exc/core/src/models/Solution';

const baseConfig = {
  access: {
    code: ['acp', 'bso'],
    codeFlagLogicOp: 'AND',
    codeLogicOp: 'AND',
    flag: 'cjm-enabled'
  },
  releaseType: RELEASE_TYPE.ALPHA
};

export const unifiedHome: Solution = {
  ...baseConfig,
  appId: 'unified-home',
  distributionList: ['Grp-TrojanRabbit'],
  path: '/unified-home',
  refreshOnImsChange: true,
  spaAppId: 'exc-unified-home',
  sandbox: {
    history: HISTORY.HISTORY,
    sources: {
      dev: 'https://localhost.corp.adobe.com:12399',
      prod: ''
    }
  },
  urlContext: {key: 'sandbox'}
};
